import { render } from "./MyContact.vue?vue&type=template&id=79d96fbf&scoped=true"
import script from "./MyContact.vue?vue&type=script&lang=js"
export * from "./MyContact.vue?vue&type=script&lang=js"

import "./MyContact.vue?vue&type=style&index=0&id=79d96fbf&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79d96fbf"]])

export default __exports__